// @ts-check
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { hasNav } from '../../helpers';
import Item from './Item';
import Submenu from './Submenu';

export const MenuDefaultWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.shades[7]};
  position: absolute;
  left: 0;
  top: 100%;
  border-bottom-left-radius: ${({ theme }) => (theme.name === 'brightworld' ? '10px' : '5px')};
  border-bottom-right-radius: ${({ theme }) => (theme.name === 'brightworld' ? '10px' : '5px')};
`;

const MenuDefaultList = styled.ul`
  background-color: ${({ theme }) => theme.colors.shades[7]};
  border-bottom-left-radius: ${({ theme }) => (theme.name === 'brightworld' ? '10px' : '5px')};
  border-bottom-right-radius: ${({ theme }) => (theme.name === 'brightworld' ? '10px' : '5px')};
  list-style: none;
  padding: 10px 0;
  margin: 0;
  box-sizing: content-box;
`;

const MenuDefault = (props) => {
  const { data } = props;
  const [linkActive, setLinkActive] = useState(false);
  const [index, setIndex] = useState(0);
  const [positionX, setPositionX] = useState(0);
  const [mouseMoving, setMouseMoving] = useState(false);

  const handleActiveLink = (i, isActive) => {
    setLinkActive(isActive);
    if (mouseMoving) {
      setIndex(index);
      return;
    }
    setIndex(i);
    setPositionX(0);
  };

  const handleMouseMove = (i, e) => {
    e.preventDefault();
    setPositionX(e.clientX);

    if (positionX < e.clientX) {
      setIndex(index);
      setMouseMoving(true);
      return;
    }
    setIndex(i);
    setMouseMoving(false);
  };

  return (
    <MenuDefaultWrapper onMouseLeave={() => handleActiveLink(index, false)}>
      <MenuDefaultList>
        {
          data.map((menuItem, i) => (
            menuItem.label && (
              <li
                style={{ display: 'block' }}
                key={i}
                onMouseEnter={() => handleActiveLink(i, true)}
                onMouseMove={e => handleMouseMove(i, e)}
              >
                <Item
                  menuItem={menuItem}
                  showSubmenu={i === index && linkActive}
                />
              </li>
            )
          ))
        }
      </MenuDefaultList>
      {hasNav(data[index]) && linkActive && (
        <Submenu nav={data[index].nav} />
      )}
    </MenuDefaultWrapper>
  );
};

MenuDefault.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        label: PropTypes.string,
        link: PropTypes.string,
        nav: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            link: PropTypes.string,
            nav: PropTypes.arrayOf(
              PropTypes.shape({
                label: PropTypes.string,
                link: PropTypes.string
              })
            )
          })
        )
      }),
      PropTypes.string
    ])
  ).isRequired
};

export default MenuDefault;
